import { css } from '@/styled-system/css';

/**
 * Text style with pre-wrap white-space
 * Migrated from StyledPreWrapText
 */
export const preWrapTextStyles = css.raw({
  whiteSpace: 'pre-wrap',
});

export const minWidthZero = css.raw({
  minWidth: 0,
});

/**
 * Single line text with ellipsis
 * Migrated from StyledSingleLineText
 */
export const singleTextLineStyles = css.raw({
  display: 'block',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
});

/**
 * Adds a red asterisk after the element
 * Migrated from StyledAsteriskAfter
 */
export const asteriskAfterStyles = css.raw({
  _after: {
    content: '"\u00a0*"',
    color: 'text.accent.red.strong',
    verticalAlign: 'text-top',
  },
});

/**
 * Truncates at the second line
 * Migrated from StyledLineClamp
 */
export const lineClampStyles = css.raw({
  // @ts-expect-error -webkit-box is a valid CSS property
  display: '-webkit-box',
  '-webkit-line-clamp': 2,
  '-webkit-box-orient': 'vertical',
  overflow: 'hidden',
  width: '100%',
  wordBreak: 'break-word',
  overflowWrap: 'break-word',
});
